class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    // Measured ahead of time (idle), not on the first open: Dawn set this on
    // <html> at the moment the first menu opened, which re-styled the WHOLE
    // page mid-slide (~6000 elements) - the stutter on the first open after
    // a reload. It is only read by .mega-menu__content, so it lives on the
    // header now (a change there only touches the header).
    const pre = () => this.setBottom();
    if (window.requestIdleCallback) requestIdleCallback(pre, { timeout: 2000 });
    else setTimeout(pre, 1000);
  }

  setBottom() {
    if (!this.header || this.header.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    this.header.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;
    this.setBottom();
  }
}

customElements.define('header-menu', HeaderMenu);
